"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsolidatedList = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const ramda_1 = require("ramda");
const consolidated_list_styles_1 = require("./consolidated-list.styles");
const consolidated_list_utils_1 = require("./consolidated-list.utils");
const localization_1 = require("../../../localization");
const renderValue = (value) => {
    if ((0, ramda_1.isNil)(value)) {
        return react_1.default.createElement("span", { className: "list-value" }, "\u2014");
    }
    return (react_1.default.createElement(ui_components_1.ToolTip, { title: value, arrow: true }, react_1.default.createElement("span", { className: "list-value" }, value)));
};
const ConsolidatedList = ({ data, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const list = (0, react_1.useMemo)(() => {
        const localizedData = Object.keys(data).map((key) => ({ name: t({ key }), value: data[key] }));
        return (0, consolidated_list_utils_1.parseList)(localizedData, 'name');
    }, [data, t]);
    return (react_1.default.createElement(consolidated_list_styles_1.StyledConsolidatedListContainer, null, list.map((subList, index) => (react_1.default.createElement("div", { className: "list-column", key: index }, subList.map(({ name, value }) => (react_1.default.createElement(react_1.default.Fragment, { key: name }, react_1.default.createElement(consolidated_list_styles_1.StyledTitleText, { variant: "body2" }, name), renderValue(value)))))))));
};
exports.ConsolidatedList = ConsolidatedList;
exports.default = exports.ConsolidatedList;
